import { get } from '../../config/api/Api';
import {
  IFinalResponse,
  InitApiType,
  ApiCredentialsType,
  EndPointsNames,
} from '../../types';

const API_DOMAIN: EndPointsNames = 'ApiFileEnvironment';
const ENDPOINT_API_PATH = 'mfe-apps/check-env.txt';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';

const call = async (): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const timestamp = new Date().getTime();
    const init: InitApiType = {
      params: {
        t: timestamp,
      },
    };

    const response = await get(
      API_DOMAIN,
      ENDPOINT_API_PATH,
      API_CREDENTIALS_TYPE,
      init,
    );
    result.success = true;
    result.data = response.response;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call };
